import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { LqsPage } from "~/lqs/layout";
import { TagCreateForm } from "./components/TagCreateForm";

export function NewTagPage() {
  return (
    <LqsPage title="New Tag">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <TagCreateForm />
      </Container>
    </LqsPage>
  );
}
